import { Button } from '@change/ds-core-ui';

import { useResolvedLabel } from '../hooks/useResolvedLabel';

import { ICON_BY_CHANNEL } from './constants';
import { useShareChannelButton } from './hooks/useShareChannelButton';
import type { ShareChannelButtonConfig } from './types';

export type { ShareChannelButtonChannel, ShareChannelButtonConfig, TranslatableLabel } from './types';

type Props = {
	buttonConfig: ShareChannelButtonConfig;
	onBeforeShare?: () => void;
};

export const ShareChannelButton = ({
	buttonConfig: { ShareAction, label, channel, successLabel },
	onBeforeShare,
	...rest // for data attributes
}: Props): React.JSX.Element => {
	const IconComponent = ICON_BY_CHANNEL[channel];

	const { data, actions } = useShareChannelButton({ label, successLabel });

	const ariaLabel = useResolvedLabel(data.buttonLabel);
	const buttonLabel = useResolvedLabel(data.buttonLabel);

	return (
		<ShareAction onBeforeAction={onBeforeShare} onAfterAction={actions.afterShare}>
			<Button
				aria-label={ariaLabel}
				aria-disabled={data.clickedState}
				data-testid={`${channel}-share-button`}
				variant="primary"
				size="small"
				leadingIcon={IconComponent}
				{...rest}
			>
				{buttonLabel}
			</Button>
		</ShareAction>
	);
};
